import { StringBundle } from '../localizer/stringBundle'

export const strings = {
  bundles: [StringBundle.BTF],
  strings: ['DV_DP_live_badge_text'] as const,
}
